import Vue from 'vue';
import PxCamposProdutoTotvs from '@/modules/produtos/campos-erp/PxCamposProdutoTotvs.vue';
import PxCamposFornecedorTotvs
  from '@/modules/gestao-fornecedor/gestao/campos-erp/PxCamposFornecedorTotvs.vue';
import PxCamposCompraTotvs from '@/modules/carrinho/finalizacao/campos-erp/PxCamposCompraTotvs.vue';
import PxCamposCompraItemTableTotvs
  from '@/modules/carrinho/finalizacao/item-campos-erp/PxCamposCompraItemTableTotvs.vue';
import PxCamposCompraViewTotvs from '@/modules/compra/detalhes/views-erp/compra/PxCamposCompraViewTotvs.vue';
import PxCamposCompraProdutosViewTotvs
  from '@/modules/compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewTotvs.vue';
import PxCamposCompraItemTotvs from '@/modules/compra/cadastro/campos-erp/PxCamposCompraItemTotvs.vue';
import PxCamposCompraNeo from '@/modules/carrinho/finalizacao/campos-erp/PxCamposCompraNeo.vue';
import PxCamposCompraItemTableNeo
  from '@/modules/carrinho/finalizacao/item-campos-erp/PxCamposCompraItemTableNeo.vue';
import PxCamposCompraProdutosViewNeo
  from '@/modules/compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewNeo.vue';
import PxCamposCompraItemNeo from '@/modules/compra/cadastro/campos-erp/PxCamposCompraItemNeo.vue';
import PxCamposCompraSankhya
  from '@/modules/carrinho/finalizacao/campos-erp/PxCamposCompraSankhya.vue';
import PxCamposCompraViewSankhya from '@/modules/compra/detalhes/views-erp/compra/PxCamposCompraViewSankhya.vue';
import PxCamposCompraItemTableSankhya
  from '@/modules/carrinho/finalizacao/item-campos-erp/PxCamposCompraItemTableSankhya.vue';
import PxCamposCompraItemSankhya from '@/modules/compra/cadastro/campos-erp/PxCamposCompraItemSankhya.vue';
import PxCamposProdutoNeo from '@/modules/produtos/campos-erp/PxCamposProdutoNeo.vue';
import PxCamposProdutoSankhya from '@/modules/produtos/campos-erp/PxCamposProdutoSankhya.vue';
import PxCamposFornecedorNeo
  from '@/modules/gestao-fornecedor/gestao/campos-erp/PxCamposFornecedorNeo.vue';
import PxCamposFornecedorSankhya
  from '@/modules/gestao-fornecedor/gestao/campos-erp/PxCamposFornecedorSankhya.vue';
import PxCamposCompraProjedata
  from '@/modules/carrinho/finalizacao/campos-erp/PxCamposCompraProjedata.vue';
import PxCamposCompraViewProjedata
  from '@/modules/compra/detalhes/views-erp/compra/PxCamposCompraViewProjedata.vue';
import PxCamposCompraProdutosViewProjedata
  from '@/modules/compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewProjedata.vue';
import PxCamposCompraItemM8 from '@/modules/compra/cadastro/campos-erp/PxCamposCompraItemM8.vue';
import PxCamposCompraViewM8
  from '@/modules/compra/detalhes/views-erp/compra/PxCamposCompraViewM8.vue';
import PxCamposCompraProdutosViewM8
  from '@/modules/compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewM8.vue';
import PxCamposRequisicaoItemTotvs
  from '@/modules/requisicao/cadastro/campos-erp/PxCamposRequisicaoItemTotvs.vue';
import PxCamposRequisicaoProdutosViewTotvs
  from '@/modules/requisicao/detalhes/campos-erp/PxCamposRequisicaoProdutosViewTotvs.vue';
import PxCamposCompraViewSapB1
  from '@/modules/compra/detalhes/views-erp/compra/PxCamposCompraViewSapB1.vue';
import PxCamposCompraSapB1 from '@/modules/carrinho/finalizacao/campos-erp/PxCamposCompraSapB1.vue';
import PxCamposProdutoSapB1 from '@/modules/produtos/campos-erp/PxCamposProdutoSapB1.vue';
import PxCamposCompraProdutosViewSapB1
  from '@/modules/compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewSapB1.vue';
import PxCamposCompraItemSapB1
  from '@/modules/compra/cadastro/campos-erp/PxCamposCompraItemSapB1.vue';
import PxCamposProdutoM365BuscheLepper from '@/modules/produtos/campos-erp/PxCamposProdutoM365BuscheLepper.vue';
import PxCamposCompraProdutosViewM365BuscheLepper
  from '@/modules/compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewM365BuscheLepper.vue';
import PxCamposCompraM365BuscheLepper from '@/modules/carrinho/finalizacao/campos-erp/PxCamposCompraM365BuscheLepper.vue';
import PxCamposCompraViewM365BuscheLepper from '@/modules/compra/detalhes/views-erp/compra/PxCamposCompraViewM365BuscheLepper.vue';
import PxCamposCompraItemTableM365BuscheLepper
  from '@/modules/carrinho/finalizacao/item-campos-erp/PxCamposCompraItemTableM365BuscheLepper.vue';
import PxCamposCompraItemM365BuscheLepper from '@/modules/compra/cadastro/campos-erp/PxCamposCompraItemM365BuscheLepper.vue';
import PxCamposRequisicaoItemM365BuscheLepper
  from '@/modules/requisicao/cadastro/campos-erp/PxCamposRequisicaoItemM365BuscheLepper.vue';
import PxCamposRequisicaoProdutosViewM365BuscheLepper
  from '@/modules/requisicao/detalhes/campos-erp/PxCamposRequisicaoProdutosViewM365BuscheLepper.vue';

import PxCamposCompraUseallSetup from './carrinho/finalizacao/campos-erp/PxCamposCompraUseallSetup.vue';
import PxCamposCompraViewUseallSetup from './compra/detalhes/views-erp/compra/PxCamposCompraViewUseallSetup.vue';
import PxCamposCompraItemTableUseallSetup from './carrinho/finalizacao/item-campos-erp/PxCamposCompraItemTableUseallSetup.vue';
import PxCamposProdutoUseallSetup from './produtos/campos-erp/PxCamposProdutoUseallSetup.vue';
import PxCamposCompraItemUseallSetup from './compra/cadastro/campos-erp/PxCamposCompraItemUseallSetup.vue';
import PxCamposCompraProdutosViewUseallSetup from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewUseallSetup.vue';
import PxCamposCompraItemTableSenior from './carrinho/finalizacao/item-campos-erp/PxCamposCompraItemTableSenior.vue';
import PxCamposCompraSenior from './carrinho/finalizacao/campos-erp/PxCamposCompraSenior.vue';
import PxCamposProdutoSenior from './produtos/campos-erp/PxCamposProdutoSenior.vue';
import PxCamposFornecedorSenior from './gestao-fornecedor/gestao/campos-erp/PxCamposFornecedorSenior.vue';
import PxCamposCompraItemSenior from './compra/cadastro/campos-erp/PxCamposCompraItemSenior.vue';
import PxCamposCompraProdutosViewSenior from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewSenior.vue';
import PxCamposCompraViewSenior from './compra/detalhes/views-erp/compra/PxCamposCompraViewSenior.vue';
import PxCamposCompraItemSeniorTeixeira from './compra/cadastro/campos-erp/PxCamposCompraItemSeniorTeixeira.vue';
import PxCamposCompraSeniorTeixeira from './carrinho/finalizacao/campos-erp/PxCamposCompraSeniorTeixeira.vue';
import PxCamposProdutoSeniorTeixeira from './produtos/campos-erp/PxCamposProdutoSeniorTeixeira.vue';
import PxCamposCompraItemTableSeniorTeixeira from './carrinho/finalizacao/item-campos-erp/PxCamposCompraItemTableSeniorTeixeira.vue';
import PxCamposCompraProdutosViewSeniorTeixeira from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewSeniorTeixeira.vue';
import PxCamposCompraViewSeniorTeixeira from './compra/detalhes/views-erp/compra/PxCamposCompraViewSeniorTeixeira.vue';
import PxCamposFornecedorSeniorTeixeira from './gestao-fornecedor/gestao/campos-erp/PxCamposFornecedorSeniorTeixeira.vue';
import PxCamposCompraItemLm from './compra/cadastro/campos-erp/PxCamposCompraItemLm.vue';
import PxCamposCompraLm from './carrinho/finalizacao/campos-erp/PxCamposCompraLm.vue';
import PxCamposCompraM8 from './carrinho/finalizacao/campos-erp/PxCamposCompraM8.vue';
import PxCamposProdutoLm from './produtos/campos-erp/PxCamposProdutoLm.vue';
import PxCamposCompraItemTableLm from './carrinho/finalizacao/item-campos-erp/PxCamposCompraItemTableLm.vue';
import PxCamposCompraViewLm from './compra/detalhes/views-erp/compra/PxCamposCompraViewLm.vue';
import PxCamposFornecedorLm from './gestao-fornecedor/gestao/campos-erp/PxCamposFornecedorLm.vue';
import PxCamposCompraProdutosViewLm from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewLm.vue';
import PxCamposCompraItemUseall from './compra/cadastro/campos-erp/PxCamposCompraItemUseall.vue';
import PxCamposCompraUseall from './carrinho/finalizacao/campos-erp/PxCamposCompraUseall.vue';
import PxCamposCompraItemTableUseall from './carrinho/finalizacao/item-campos-erp/PxCamposCompraItemTableUseall.vue';
import PxCamposCompraViewUseall from './compra/detalhes/views-erp/compra/PxCamposCompraViewUseall.vue';
import PxCamposFornecedorUseall from './gestao-fornecedor/gestao/campos-erp/PxCamposFornecedorUseall.vue';
import PxCamposProdutoUseall from './produtos/campos-erp/PxCamposProdutoUseall.vue';
import PxCamposCompraProdutosViewUseall from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewUseall.vue';
import PxCamposCompraViewNeo from './compra/detalhes/views-erp/compra/PxCamposCompraViewNeo.vue';
import PxCamposCompraItemProjedata from './compra/cadastro/campos-erp/PxCamposCompraItemProjedata.vue';
import PxCamposCompraItemNeoG7 from './compra/cadastro/campos-erp/PxCamposCompraItemNeoG7.vue';
import PxCamposCompraItemTableNeoG7 from './carrinho/finalizacao/item-campos-erp/PxCamposCompraItemTableNeoG7.vue';
import PxCamposCompraProdutosViewNeoG7 from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewNeoG7.vue';
import PxCamposProdutoNeoG7 from './produtos/campos-erp/PxCamposProdutoNeoG7.vue';
import PxCamposRequisicaoItemCrmSolucoes from './requisicao/cadastro/campos-erp/PxCamposRequisicaoItemCrmSolucoes.vue';
import PxCamposRequisicaoProdutosViewCrmSolucoes from './requisicao/detalhes/campos-erp/PxCamposRequisicaoProdutosViewCrmSolucoes.vue';
import PxCamposProdutoCrmSolucoes from './produtos/campos-erp/PxCamposProdutoCrmSolucoes.vue';
import PxCamposCompraItemCrmSolucoes from './compra/cadastro/campos-erp/PxCamposCompraItemCrmSolucoes.vue';
import PxCamposCompraProdutosViewCrmSolucoes from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewCrmSolucoes.vue';
import PxCamposProdutoFocco from './produtos/campos-erp/PxCamposProdutoFocco.vue';
import PxCamposCompraItemFocco from './compra/cadastro/campos-erp/PxCamposCompraItemFocco.vue';
import PxCamposCompraProdutosViewFocco from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewFocco.vue';
import PxCamposRequisicaoItemFocco from './requisicao/cadastro/campos-erp/PxCamposRequisicaoItemFocco.vue';
import PxCamposRequisicaoProdutosViewFocco from './requisicao/detalhes/campos-erp/PxCamposRequisicaoProdutosViewFocco.vue';
import PxCamposCotacaoItemFocco from './cotacao/cadastro/produtos/campos-erp/PxCamposCotacaoItemFocco.vue';
import PxCamposCotacaoProdutosViewFocco from './cotacao/resposta/detalhes/views-erp/PxCamposCotacaoProdutosViewFocco.vue';
import PxCamposRequisicaoItemSeniorMega from './requisicao/cadastro/campos-erp/PxCamposRequisicaoItemSeniorMega.vue';
import PxCamposProdutoSeniorMega from './produtos/campos-erp/PxCamposProdutoSeniorMega.vue';
import PxCamposCompraItemSeniorMega from './compra/cadastro/campos-erp/PxCamposCompraItemSeniorMega.vue';
import PxCamposRequisicaoProdutosViewSeniorMega from './requisicao/detalhes/campos-erp/PxCamposRequisicaoProdutosViewSeniorMega.vue';
import PxCamposCompraProdutosViewSeniorMega from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewSeniorMega.vue';
import PxCamposCompraItemNeoGabriella from './compra/cadastro/campos-erp/PxCamposCompraItemNeoGabriella.vue';
import PxCamposProdutoNeoGabriella from './produtos/campos-erp/PxCamposProdutoNeoGabriella.vue';
import PxCamposCompraViewNeoGabriella from './compra/detalhes/views-erp/compra/PxCamposCompraViewNeoGabriella.vue';
import PxCamposCompraItemCasaShopping from './compra/cadastro/campos-erp/PxCamposCompraItemCasaShopping.vue';
import PxCamposCompraNeoGabriella from './carrinho/finalizacao/campos-erp/PxCamposCompraNeoGabriella.vue';
import PxCamposProdutoCasaShopping from './produtos/campos-erp/PxCamposProdutoCasaShopping.vue';
import PxCamposRequisicaoItemCasaShopping from './requisicao/cadastro/campos-erp/PxCamposRequisicaoItemCasaShopping.vue';
import PxCamposRequisicaoProdutosViewCasaShopping from './requisicao/detalhes/campos-erp/PxCamposRequisicaoProdutosViewCasaShopping.vue';
import PxCamposCompraProdutosViewCasaShopping from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewCasaShopping.vue';
import PxCamposCotacaoItemCasaShopping from './cotacao/cadastro/produtos/campos-erp/PxCamposCotacaoItemCasaShopping.vue';
import PxCamposCotacaoProdutosViewCasaShopping from './cotacao/resposta/detalhes/views-erp/PxCamposCotacaoProdutosViewCasaShopping.vue';
import PxCamposCompraItemCondor from './compra/cadastro/campos-erp/PxCamposCompraItemCondor.vue';
import PxCamposCompraProdutosViewCondor from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewCondor.vue';
import PxCamposRequisicaoItemCondor from './requisicao/cadastro/campos-erp/PxCamposRequisicaoItemCondor.vue';
import PxCamposRequisicaoProdutosViewCondor from './requisicao/detalhes/campos-erp/PxCamposRequisicaoProdutosViewCondor.vue';
import PxCamposProdutoCondor from './produtos/campos-erp/PxCamposProdutoCondor.vue';
import PxCamposCompraCigam from './carrinho/finalizacao/campos-erp/PxCamposCompraCigam.vue';
import PxCamposCompraViewCigam from './compra/detalhes/views-erp/compra/PxCamposCompraViewCigam.vue';
import PxCamposCompraItemCigam from './compra/cadastro/campos-erp/PxCamposCompraItemCigam.vue';
import PxCamposCompraProdutosViewCigam from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewCigam.vue';
import PxCamposProdutoCigam from './produtos/campos-erp/PxCamposProdutoCigam.vue';
import PxCamposProdutoSankhyaNorsil from './produtos/campos-erp/PxCamposProdutoSankhyaNorsil.vue';
import PxCamposCompraSankhyaNorsil from './carrinho/finalizacao/campos-erp/PxCamposCompraSankhyaNorsil.vue';
import PxCamposCompraViewSankhyaNorsil from './compra/detalhes/views-erp/compra/PxCamposCompraViewSankhyaNorsil.vue';
import PxCamposCompraItemSankhyaNorsil from './compra/cadastro/campos-erp/PxCamposCompraItemSankhyaNorsil.vue';
import PxCamposCompraProdutosViewSankhyaNorsil from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewSankhyaNorsil.vue';
import PxCamposRequisicaoSankhyaNorsil from './requisicao/cadastro/campos-erp/requisicao/PxCamposRequisicaoSankhyaNorsil.vue';
import PxCamposRequisicaoViewSankhyaNorsil from './requisicao/detalhes/campos-erp/requisicao/PxCamposRequisicaoViewSankhyaNorsil.vue';
import PxCamposProdutoSankhyaArtLatex from './produtos/campos-erp/PxCamposProdutoSankhyaArtLatex.vue';
import PxCamposCompraSankhyaArtLatex from './carrinho/finalizacao/campos-erp/PxCamposCompraSankhyaArtLatex.vue';
import PxCamposCompraViewSankhyaArtLatex from './compra/detalhes/views-erp/compra/PxCamposCompraViewSankhyaArtLatex.vue';
import PxCamposCompraItemSankhyaArtLatex from './compra/cadastro/campos-erp/PxCamposCompraItemSankhyaArtLatex.vue';
import PxCamposCompraProdutosViewSankhyaArtLatex from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewSankhyaArtLatex.vue';
import PxCamposRequisicaoSankhyaArtLatex from './requisicao/cadastro/campos-erp/requisicao/PxCamposRequisicaoSankhyaArtLatex.vue';
import PxCamposRequisicaoViewSankhyaArtLatex from './requisicao/detalhes/campos-erp/requisicao/PxCamposRequisicaoViewSankhyaArtLatex.vue';
import PxCamposRequisicaoItemSapB1 from './requisicao/cadastro/campos-erp/PxCamposRequisicaoItemSapB1.vue';
import PxCamposRequisicaoProdutosViewSapB1 from './requisicao/detalhes/campos-erp/PxCamposRequisicaoProdutosViewSapB1.vue';
import PxCamposRequisicaoItemSeniorPfiffner from './requisicao/cadastro/campos-erp/PxCamposRequisicaoItemSeniorPfiffner.vue';
import PxCamposRequisicaoProdutosViewSeniorPfiffner from './requisicao/detalhes/campos-erp/PxCamposRequisicaoProdutosViewSeniorPfiffner.vue';
import PxCamposCompraItemTotvsProtheus from './compra/cadastro/campos-erp/PxCamposCompraItemTotvsProtheus.vue';
import PxCamposProdutoTotvsProtheus from './produtos/campos-erp/PxCamposProdutoTotvsProtheus.vue';
import PxCamposCompraProdutosViewTotvsProtheus from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewTotvsProtheus.vue';
import PxCamposRequisicaoItemTotvsProtheus from './requisicao/cadastro/campos-erp/PxCamposRequisicaoItemTotvsProtheus.vue';
import PxCamposRequisicaoProdutosViewTotvsProtheus from './requisicao/detalhes/campos-erp/PxCamposRequisicaoProdutosViewTotvsProtheus.vue';
import PxCamposProdutoEliteSoft from './produtos/campos-erp/PxCamposProdutoEliteSoft.vue';
import PxCamposCompraItemEliteSoft from './compra/cadastro/campos-erp/PxCamposCompraItemEliteSoft.vue';
import PxCamposCompraProdutosViewEliteSoft from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewEliteSoft.vue';
import PxCamposRequisicaoItemEliteSoft from './requisicao/cadastro/campos-erp/PxCamposRequisicaoItemEliteSoft.vue';
import PxCamposRequisicaoProdutosViewEliteSoft from './requisicao/detalhes/campos-erp/PxCamposRequisicaoProdutosViewEliteSoft.vue';
import PxCamposCotacaoItemEliteSoft from './cotacao/cadastro/produtos/campos-erp/PxCamposCotacaoItemEliteSoft.vue';
import PxCamposCotacaoProdutosViewEliteSoft from './cotacao/resposta/detalhes/views-erp/PxCamposCotacaoProdutosViewEliteSoft.vue';


// Campos Totvs
Vue.component('PxCamposProdutoTotvs', PxCamposProdutoTotvs);
Vue.component('PxCamposFornecedorTotvs', PxCamposFornecedorTotvs);
Vue.component('PxCamposCompraTotvs', PxCamposCompraTotvs);
Vue.component('PxCamposCompraItemTableTotvs', PxCamposCompraItemTableTotvs);
Vue.component('PxCamposCompraViewTotvs', PxCamposCompraViewTotvs);
Vue.component('PxCamposCompraProdutosViewTotvs', PxCamposCompraProdutosViewTotvs);
Vue.component('PxCamposCompraItemTotvs', PxCamposCompraItemTotvs);
Vue.component('PxCamposRequisicaoItemTotvs', PxCamposRequisicaoItemTotvs);
Vue.component('PxCamposRequisicaoProdutosViewTotvs', PxCamposRequisicaoProdutosViewTotvs);

// Campos Totvs Protheus
Vue.component('PxCamposProdutoTotvsProtheus', PxCamposProdutoTotvsProtheus);
Vue.component('PxCamposCompraProdutosViewTotvsProtheus', PxCamposCompraProdutosViewTotvsProtheus);
Vue.component('PxCamposCompraItemTotvsProtheus', PxCamposCompraItemTotvsProtheus);
Vue.component('PxCamposRequisicaoItemTotvsProtheus', PxCamposRequisicaoItemTotvsProtheus);
Vue.component('PxCamposRequisicaoProdutosViewTotvsProtheus', PxCamposRequisicaoProdutosViewTotvsProtheus);
// Aqui reutilizamos os campos do TOTVS
Vue.component('PxCamposCompraTotvsProtheus', PxCamposCompraTotvs);
Vue.component('PxCamposFornecedorTotvsProtheus', PxCamposFornecedorTotvs);
Vue.component('PxCamposCompraViewTotvsProtheus', PxCamposCompraViewTotvs);

// Campos Totvs Busche Lepper
Vue.component('PxCamposProdutoM365BuscheLepper', PxCamposProdutoM365BuscheLepper);
Vue.component('PxCamposCompraM365BuscheLepper', PxCamposCompraM365BuscheLepper);
Vue.component('PxCamposCompraItemTableM365BuscheLepper', PxCamposCompraItemTableM365BuscheLepper);
Vue.component('PxCamposCompraViewM365BuscheLepper', PxCamposCompraViewM365BuscheLepper);
Vue.component('PxCamposCompraProdutosViewM365BuscheLepper', PxCamposCompraProdutosViewM365BuscheLepper);
Vue.component('PxCamposCompraItemM365BuscheLepper', PxCamposCompraItemM365BuscheLepper);
Vue.component('PxCamposRequisicaoItemM365BuscheLepper', PxCamposRequisicaoItemM365BuscheLepper);
Vue.component('PxCamposRequisicaoProdutosViewM365BuscheLepper', PxCamposRequisicaoProdutosViewM365BuscheLepper);

// Campos NEO
Vue.component('PxCamposCompraNeo', PxCamposCompraNeo);
Vue.component('PxCamposCompraItemTableNeo', PxCamposCompraItemTableNeo);
Vue.component('PxCamposCompraProdutosViewNeo', PxCamposCompraProdutosViewNeo);
Vue.component('PxCamposCompraItemNeo', PxCamposCompraItemNeo);
Vue.component('PxCamposProdutoNeo', PxCamposProdutoNeo);
Vue.component('PxCamposFornecedorNeo', PxCamposFornecedorNeo);
Vue.component('PxCamposCompraViewNeo', PxCamposCompraViewNeo);

// Campos NEO com personalização para G7
Vue.component('PxCamposCompraItemNeoG7', PxCamposCompraItemNeoG7);
Vue.component('PxCamposCompraItemTableNeoG7', PxCamposCompraItemTableNeoG7);
Vue.component('PxCamposCompraProdutosViewNeoG7', PxCamposCompraProdutosViewNeoG7);
Vue.component('PxCamposProdutoNeoG7', PxCamposProdutoNeoG7);

// Campos NEO com personalização para Gabriealla
Vue.component('PxCamposCompraItemNeoGabriella', PxCamposCompraItemNeoGabriella);
Vue.component('PxCamposProdutoNeoGabriella', PxCamposProdutoNeoGabriella);
Vue.component('PxCamposCompraProdutosViewNeoGabriella', PxCamposCompraProdutosViewNeo);
Vue.component('PxCamposCompraNeoGabriella', PxCamposCompraNeoGabriella);
Vue.component('PxCamposCompraViewNeoGabriella', PxCamposCompraViewNeoGabriella);

// Campos Sankhya
Vue.component('PxCamposCompraSankhya', PxCamposCompraSankhya);
Vue.component('PxCamposCompraViewSankhya', PxCamposCompraViewSankhya);
Vue.component('PxCamposCompraItemTableSankhya', PxCamposCompraItemTableSankhya);
Vue.component('PxCamposCompraItemSankhya', PxCamposCompraItemSankhya);
Vue.component('PxCamposProdutoSankhya', PxCamposProdutoSankhya);
Vue.component('PxCamposFornecedorSankhya', PxCamposFornecedorSankhya);

// Campos Norsil
Vue.component('PxCamposProdutoSankhyaNorsil', PxCamposProdutoSankhyaNorsil);
Vue.component('PxCamposCompraSankhyaNorsil', PxCamposCompraSankhyaNorsil);
Vue.component('PxCamposCompraViewSankhyaNorsil', PxCamposCompraViewSankhyaNorsil);
Vue.component('PxCamposRequisicaoSankhyaNorsil', PxCamposRequisicaoSankhyaNorsil);
Vue.component('PxCamposRequisicaoViewSankhyaNorsil', PxCamposRequisicaoViewSankhyaNorsil);
Vue.component('PxCamposCompraItemSankhyaNorsil', PxCamposCompraItemSankhyaNorsil);
Vue.component('PxCamposCompraProdutosViewSankhyaNorsil', PxCamposCompraProdutosViewSankhyaNorsil);

// Campos ART LATEX
Vue.component('PxCamposCompraSankhyaArtLatex', PxCamposCompraSankhyaArtLatex);
Vue.component('PxCamposProdutoSankhyaArtLatex', PxCamposProdutoSankhyaArtLatex);
Vue.component('PxCamposRequisicaoSankhyaArtLatex', PxCamposRequisicaoSankhyaArtLatex);
Vue.component('PxCamposRequisicaoViewSankhyaArtLatex', PxCamposRequisicaoViewSankhyaArtLatex);
Vue.component('PxCamposCompraViewSankhyaArtLatex', PxCamposCompraViewSankhyaArtLatex);
Vue.component('PxCamposCompraItemSankhyaArtLatex', PxCamposCompraItemSankhyaArtLatex);
Vue.component('PxCamposCompraProdutosViewSankhyaArtLatex', PxCamposCompraProdutosViewSankhyaArtLatex);

// Campos Senior
Vue.component('PxCamposCompraSenior', PxCamposCompraSenior);
Vue.component('PxCamposCompraViewSenior', PxCamposCompraViewSenior);
Vue.component('PxCamposCompraItemTableSenior', PxCamposCompraItemTableSenior);
Vue.component('PxCamposCompraItemSenior', PxCamposCompraItemSenior);
Vue.component('PxCamposProdutoSenior', PxCamposProdutoSenior);
Vue.component('PxCamposFornecedorSenior', PxCamposFornecedorSenior);
Vue.component('PxCamposCompraProdutosViewSenior', PxCamposCompraProdutosViewSenior);

// Campos Cigam
Vue.component('PxCamposCompraCigam', PxCamposCompraCigam);
Vue.component('PxCamposCompraViewCigam', PxCamposCompraViewCigam);
Vue.component('PxCamposCompraItemCigam', PxCamposCompraItemCigam);
Vue.component('PxCamposCompraProdutosViewCigam', PxCamposCompraProdutosViewCigam);
Vue.component('PxCamposProdutoCigam', PxCamposProdutoCigam);

// Campos Senior Teixeira
Vue.component('PxCamposCompraItemSeniorTeixeira', PxCamposCompraItemSeniorTeixeira);
Vue.component('PxCamposCompraSeniorTeixeira', PxCamposCompraSeniorTeixeira);
Vue.component('PxCamposProdutoSeniorTeixeira', PxCamposProdutoSeniorTeixeira);
Vue.component('PxCamposCompraItemTableSeniorTeixeira', PxCamposCompraItemTableSeniorTeixeira);
Vue.component('PxCamposCompraProdutosViewSeniorTeixeira', PxCamposCompraProdutosViewSeniorTeixeira);
Vue.component('PxCamposCompraViewSeniorTeixeira', PxCamposCompraViewSeniorTeixeira);
Vue.component('PxCamposFornecedorSeniorTeixeira', PxCamposFornecedorSeniorTeixeira);

// Campos Senior Medal
Vue.component('PxCamposCompraSeniorMedal', PxCamposCompraSenior);
Vue.component('PxCamposCompraViewSeniorMedal', PxCamposCompraViewSenior);
Vue.component('PxCamposCompraItemTableSeniorMedal', PxCamposCompraItemTableSenior);
Vue.component('PxCamposCompraItemSeniorMedal', PxCamposCompraItemSenior);
Vue.component('PxCamposProdutoSeniorMedal', PxCamposProdutoSenior);
Vue.component('PxCamposFornecedorSeniorMedal', PxCamposFornecedorSenior);
Vue.component('PxCamposCompraProdutosViewSeniorMedal', PxCamposCompraProdutosViewSenior);

// Campos LM
Vue.component('PxCamposCompraItemLm', PxCamposCompraItemLm);
Vue.component('PxCamposCompraLm', PxCamposCompraLm);
Vue.component('PxCamposProdutoLm', PxCamposProdutoLm);
Vue.component('PxCamposCompraItemTableLm', PxCamposCompraItemTableLm);
Vue.component('PxCamposCompraViewLm', PxCamposCompraViewLm);
Vue.component('PxCamposFornecedorLm', PxCamposFornecedorLm);
Vue.component('PxCamposCompraProdutosViewLm', PxCamposCompraProdutosViewLm);

// Campos Useall
Vue.component('PxCamposCompraItemUseall', PxCamposCompraItemUseall);
Vue.component('PxCamposCompraUseall', PxCamposCompraUseall);
Vue.component('PxCamposProdutoUseall', PxCamposProdutoUseall);
Vue.component('PxCamposCompraItemTableUseall', PxCamposCompraItemTableUseall);
Vue.component('PxCamposCompraViewUseall', PxCamposCompraViewUseall);
Vue.component('PxCamposFornecedorUseall', PxCamposFornecedorUseall);
Vue.component('PxCamposCompraProdutosViewUseall', PxCamposCompraProdutosViewUseall);

// Campos Useall Procer a unica personalização deles pelo ERP é a obrigatorieadade de campos.
Vue.component('PxCamposCompraItemUseallProcer', PxCamposCompraItemUseall);
Vue.component('PxCamposCompraUseallProcer', PxCamposCompraUseall);
Vue.component('PxCamposProdutoUseallProcer', PxCamposProdutoUseall);
Vue.component('PxCamposCompraItemTableUseallProcer', PxCamposCompraItemTableUseall);
Vue.component('PxCamposCompraViewUseallProcer', PxCamposCompraViewUseall);
Vue.component('PxCamposFornecedorUseallProcer', PxCamposFornecedorUseall);
Vue.component('PxCamposCompraProdutosViewUseallProcer', PxCamposCompraProdutosViewUseall);

// Campos Useall Setup
Vue.component('PxCamposCompraUseallSetup', PxCamposCompraUseallSetup);
Vue.component('PxCamposCompraViewUseallSetup', PxCamposCompraViewUseallSetup);
Vue.component('PxCamposCompraItemUseallSetup', PxCamposCompraItemUseallSetup);
Vue.component('PxCamposProdutoUseallSetup', PxCamposProdutoUseallSetup);
Vue.component('PxCamposCompraItemTableUseallSetup', PxCamposCompraItemTableUseallSetup);
Vue.component('PxCamposCompraProdutosViewUseallSetup', PxCamposCompraProdutosViewUseallSetup);
// Esses abaixo são os mesmos que usamos para Useall
Vue.component('PxCamposFornecedorUseallSetup', PxCamposFornecedorUseall);

// Campos M8
Vue.component('PxCamposCompraM8', PxCamposCompraM8);
Vue.component('PxCamposCompraItemM8', PxCamposCompraItemM8);
Vue.component('PxCamposCompraViewM8', PxCamposCompraViewM8);
Vue.component('PxCamposCompraProdutosViewM8', PxCamposCompraProdutosViewM8);

// Campos projedata
Vue.component('PxCamposCompraProjedata', PxCamposCompraProjedata);
Vue.component('PxCamposCompraItemProjedata', PxCamposCompraItemProjedata);
Vue.component('PxCamposCompraViewProjedata', PxCamposCompraViewProjedata);
Vue.component('PxCamposCompraProdutosViewProjedata', PxCamposCompraProdutosViewProjedata);

// Campos CRM Soluções
Vue.component('PxCamposRequisicaoItemCrmSolucoes', PxCamposRequisicaoItemCrmSolucoes);
Vue.component('PxCamposRequisicaoProdutosViewCrmSolucoes', PxCamposRequisicaoProdutosViewCrmSolucoes);
Vue.component('PxCamposProdutoCrmSolucoes', PxCamposProdutoCrmSolucoes);
Vue.component('PxCamposCompraItemCrmSolucoes', PxCamposCompraItemCrmSolucoes);
Vue.component('PxCamposCompraProdutosViewCrmSolucoes', PxCamposCompraProdutosViewCrmSolucoes);

// Campos Focco
Vue.component('PxCamposProdutoFocco', PxCamposProdutoFocco);
Vue.component('PxCamposCompraItemFocco', PxCamposCompraItemFocco);
Vue.component('PxCamposCompraProdutosViewFocco', PxCamposCompraProdutosViewFocco);
Vue.component('PxCamposRequisicaoItemFocco', PxCamposRequisicaoItemFocco);
Vue.component('PxCamposRequisicaoProdutosViewFocco', PxCamposRequisicaoProdutosViewFocco);
Vue.component('PxCamposCotacaoItemFocco', PxCamposCotacaoItemFocco);
Vue.component('PxCamposCotacaoProdutosViewFocco', PxCamposCotacaoProdutosViewFocco);

// Campos Senior mega
Vue.component('PxCamposRequisicaoItemSeniorMega', PxCamposRequisicaoItemSeniorMega);
Vue.component('PxCamposProdutoSeniorMega', PxCamposProdutoSeniorMega);
Vue.component('PxCamposCompraItemSeniorMega', PxCamposCompraItemSeniorMega);
Vue.component('PxCamposRequisicaoProdutosViewSeniorMega', PxCamposRequisicaoProdutosViewSeniorMega);
Vue.component('PxCamposCompraProdutosViewSeniorMega', PxCamposCompraProdutosViewSeniorMega);

// Campos Casa shopping
Vue.component('PxCamposCompraItemCasaShopping', PxCamposCompraItemCasaShopping);
Vue.component('PxCamposProdutoCasaShopping', PxCamposProdutoCasaShopping);
Vue.component('PxCamposRequisicaoItemCasaShopping', PxCamposRequisicaoItemCasaShopping);
Vue.component('PxCamposRequisicaoProdutosViewCasaShopping', PxCamposRequisicaoProdutosViewCasaShopping);
Vue.component('PxCamposCompraProdutosViewCasaShopping', PxCamposCompraProdutosViewCasaShopping);
Vue.component('PxCamposCotacaoItemCasaShopping', PxCamposCotacaoItemCasaShopping);
Vue.component('PxCamposCotacaoProdutosViewCasaShopping', PxCamposCotacaoProdutosViewCasaShopping);

// Campos Sankhya Condor
Vue.component('PxCamposCompraItemCondor', PxCamposCompraItemCondor);
Vue.component('PxCamposCompraProdutosViewCondor', PxCamposCompraProdutosViewCondor);
Vue.component('PxCamposRequisicaoItemCondor', PxCamposRequisicaoItemCondor);
Vue.component('PxCamposRequisicaoProdutosViewCondor', PxCamposRequisicaoProdutosViewCondor);
Vue.component('PxCamposProdutoCondor', PxCamposProdutoCondor);

// Campos Sap B1
Vue.component('PxCamposCompraItemSapB1', PxCamposCompraItemSapB1);
Vue.component('PxCamposCompraProdutosViewSapB1', PxCamposCompraProdutosViewSapB1);
Vue.component('PxCamposRequisicaoItemSapB1', PxCamposRequisicaoItemSapB1);
Vue.component('PxCamposRequisicaoProdutosViewSapB1', PxCamposRequisicaoProdutosViewSapB1);
Vue.component('PxCamposProdutoSapB1', PxCamposProdutoSapB1);
Vue.component('PxCamposCompraSapB1', PxCamposCompraSapB1);
Vue.component('PxCamposCompraViewSapB1', PxCamposCompraViewSapB1);

// Campos Senior Pfiffner, Personalizações de validação
Vue.component('PxCamposCompraSeniorPfiffner', PxCamposCompraSenior);
Vue.component('PxCamposCompraViewSeniorPfiffner', PxCamposCompraViewSenior);
Vue.component('PxCamposCompraItemTableSeniorPfiffner', PxCamposCompraItemTableSenior);
Vue.component('PxCamposCompraItemSeniorPfiffner', PxCamposCompraItemSenior);
Vue.component('PxCamposProdutoSeniorPfiffner', PxCamposProdutoSenior);
Vue.component('PxCamposFornecedorSeniorPfiffner', PxCamposFornecedorSenior);
Vue.component('PxCamposCompraProdutosViewSeniorPfiffner', PxCamposCompraProdutosViewSenior);
Vue.component('PxCamposRequisicaoItemSeniorPfiffner', PxCamposRequisicaoItemSeniorPfiffner);
Vue.component('PxCamposRequisicaoProdutosViewSeniorPfiffner', PxCamposRequisicaoProdutosViewSeniorPfiffner);

// Campos Elite Soft
Vue.component('PxCamposProdutoEliteSoft', PxCamposProdutoEliteSoft);
Vue.component('PxCamposCompraItemEliteSoft', PxCamposCompraItemEliteSoft);
Vue.component('PxCamposCompraProdutosViewEliteSoft', PxCamposCompraProdutosViewEliteSoft);
Vue.component('PxCamposRequisicaoItemEliteSoft', PxCamposRequisicaoItemEliteSoft);
Vue.component('PxCamposRequisicaoProdutosViewEliteSoft', PxCamposRequisicaoProdutosViewEliteSoft);
Vue.component('PxCamposCotacaoItemEliteSoft', PxCamposCotacaoItemEliteSoft);
Vue.component('PxCamposCotacaoProdutosViewEliteSoft', PxCamposCotacaoProdutosViewEliteSoft);
